import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	edit: {
		metadata: {
			actors: [],
			writers: [],
			directors: [],
			producers: [],
			sub_category: []
		},
		genres: [],
		tags: []
	},
	isLoaded: false,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR SERIES FORM STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH VOD ******************
			case types.FETCH_VOD_DETAILS_LOADING:
				return { ...INITIAL_STATE };

			case types.FETCH_VOD_DETAILS_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_VOD_DETAILS_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
